"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalSheetResolutionsTable = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var types_1 = require("../../common/types");
var ApprovalSheetContext_1 = require("../../context/ApprovalSheetContext");
var react_intl_1 = require("react-intl");
var styles_1 = require("@material-ui/core/styles");
var utils_1 = require("../../utils");
var classnames_1 = __importDefault(require("classnames"));
var ConfirmationDialog_1 = require("../../components/ConfirmationDialog");
var useApprovalSheetResolutionsTableStyles = styles_1.makeStyles(function (theme) {
    var _a = theme.variables.palette.approval, backgroundColorBase = _a.backgroundColorBase, backgroundColorAccent = _a.backgroundColorAccent, backgroundColorError = _a.backgroundColorError, backgroundColorSelected = _a.backgroundColorSelected, colorError = _a.colorError, colorErrorDarker = _a.colorErrorDarker, colorSuccess = _a.colorSuccess, colorSuccessDarker = _a.colorSuccessDarker, colorDisabled = _a.colorDisabled, colorBlack = _a.colorBlack;
    return {
        row: {
            backgroundColor: backgroundColorAccent + " !important",
            borderTop: "1px solid " + backgroundColorBase,
            '& td': {
                verticalAlign: 'middle',
            },
        },
        rowCurrent: {
            backgroundColor: backgroundColorSelected + " !important",
        },
        rowReject: {
            backgroundColor: backgroundColorError + " !important",
        },
        cellApprove: {
            color: colorSuccess,
        },
        cellReject: {
            color: colorError,
        },
        cellActive: {
            color: colorBlack,
            fontWeight: 'bold',
        },
        buttonSuccess: {
            background: colorSuccess + " !important",
            color: backgroundColorAccent + " !important",
            '&:hover': {
                background: colorSuccessDarker + " !important",
            },
            '&[disabled]': {
                background: colorDisabled + " !important",
            },
        },
        buttonError: {
            background: colorError + " !important",
            color: backgroundColorAccent + " !important",
            '&:hover': {
                background: colorErrorDarker + " !important",
            },
            '&[disabled]': {
                background: colorDisabled + " !important",
            },
        },
    };
});
exports.ApprovalSheetResolutionsTable = function () {
    var _a = react_1.useContext(ApprovalSheetContext_1.ApprovalSheetContext), sheet = _a.sheet, currentUserId = _a.currentUserId, sendApprovalSheetResolution = _a.sendApprovalSheetResolution;
    var groups = sheet.groups, activeGroupId = sheet.activeGroupId, statusType = sheet.statusType, _b = sheet.id, id = _b === void 0 ? '' : _b;
    var _c = react_1.useState(function () { return Promise.resolve(); }), onConfirmAction = _c[0], setOnConfirmAction = _c[1];
    var _d = react_1.useState(null), confirmButtonText = _d[0], setConfirmButtonText = _d[1];
    var resetOnConfirmAction = function () { return setOnConfirmAction(function () { return Promise.resolve(); }); };
    var resetConfirmButtonText = function () { return setConfirmButtonText(null); };
    var onConfirmDialogCancel = function () {
        resetConfirmButtonText();
        resetOnConfirmAction();
    };
    var sendSheetResolution = function (resolution) {
        return function (participantId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sendApprovalSheetResolution(id, resolution, participantId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
    };
    var sendApproveResolution = sendSheetResolution(types_1.ApprovalSheetResolution.APPROVE);
    var sendRejectResolution = sendSheetResolution(types_1.ApprovalSheetResolution.REJECT);
    var isActiveSheetStatus = react_1.useMemo(function () { return (statusType ? utils_1.isActiveApprovalStatus(statusType) : false); }, [statusType]);
    var isNotEndStatus = react_1.useMemo(function () { return (statusType ? !utils_1.isEndApprovalStatus(statusType) : false); }, [statusType]);
    var participants = react_1.useMemo(function () {
        return utils_1.getApprovalSheetResolutionsTableParticipants(groups, isActiveSheetStatus);
    }, [groups, activeGroupId, isActiveSheetStatus]);
    var classes = useApprovalSheetResolutionsTableStyles();
    var renderRows = function () {
        return participants.map(function (participant, index) {
            var _a, _b, _c;
            var _d = participant.id, id = _d === void 0 ? '' : _d, userId = participant.userId, fio = participant.fio, resolutionType = participant.resolutionType, groupType = participant.groupType, resolutionDate = participant.resolutionDate, isActiveParticipant = participant.isActiveParticipant, isParallel = participant.isParallel, isAfterActiveGroup = participant.isAfterActiveGroup;
            var currentUserIsParticipant = currentUserId === userId;
            var resolutionIsUndefined = resolutionType === undefined;
            var resolutionIsReject = resolutionType === types_1.ApprovalSheetResolution.REJECT;
            var resolutionIsApprove = resolutionType === types_1.ApprovalSheetResolution.APPROVE;
            var isButtonsDisabled = !isActiveParticipant;
            var buttonsWithTooltip = function (children) {
                return isButtonsDisabled ? (react_1.default.createElement(core_1.Tooltip, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "resolutionButtonTooltip" }) }, children)) : (children);
            };
            var onConfirmApproveClick = function () {
                return sendApproveResolution(id).finally(onConfirmDialogCancel);
            };
            var onConfirmRejectClick = function () {
                return sendRejectResolution(id).finally(onConfirmDialogCancel);
            };
            var approveButtonText = react_1.default.createElement(react_intl_1.FormattedMessage, { id: "resolutionButton.APPROVE_" + groupType });
            var rejectButtonText = react_1.default.createElement(react_intl_1.FormattedMessage, { id: "resolutionButton.REJECT_" + groupType });
            var onApproveClick = function () {
                setOnConfirmAction(function () { return onConfirmApproveClick; });
                setConfirmButtonText(approveButtonText);
            };
            var onRejectClick = function () {
                setOnConfirmAction(function () { return onConfirmRejectClick; });
                setConfirmButtonText(rejectButtonText);
            };
            return (react_1.default.createElement(core_1.TableRow, { key: id, className: classnames_1.default(classes.row, (_a = {},
                    _a[classes.rowCurrent] = currentUserIsParticipant && resolutionIsUndefined,
                    _a[classes.rowReject] = resolutionIsReject,
                    _a)) },
                react_1.default.createElement(core_1.TableCell, null, index + 1),
                react_1.default.createElement(core_1.TableCell, { className: classnames_1.default((_b = {}, _b[classes.cellActive] = isActiveParticipant, _b)) }, fio),
                react_1.default.createElement(core_1.TableCell, { width: "165px" },
                    react_1.default.createElement(core_1.Grid, { container: true, alignItems: "center", wrap: "nowrap", justify: "space-between", spacing: 2 },
                        resolutionType && (react_1.default.createElement(core_1.Grid, { item: true, className: classnames_1.default((_c = {},
                                _c[classes.cellApprove] = resolutionIsApprove,
                                _c[classes.cellReject] = resolutionIsReject,
                                _c)) },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "resolution." + resolutionType + "_" + groupType }))),
                        currentUserIsParticipant && isNotEndStatus && (react_1.default.createElement(core_1.Grid, { item: true }, (resolutionIsUndefined || (isParallel && isAfterActiveGroup)) &&
                            buttonsWithTooltip(react_1.default.createElement(core_1.Grid, { container: true, alignItems: "baseline", spacing: 2, wrap: "nowrap" },
                                (resolutionIsUndefined || (isParallel && resolutionIsReject)) && (react_1.default.createElement(core_1.Grid, { item: true },
                                    react_1.default.createElement(core_1.Button, { color: "primary", variant: "contained", className: classes.buttonSuccess, onClick: onApproveClick, disabled: isButtonsDisabled }, approveButtonText))),
                                (resolutionIsUndefined || (isParallel && resolutionIsApprove)) && (react_1.default.createElement(core_1.Grid, { item: true },
                                    react_1.default.createElement(core_1.Button, { color: "secondary", variant: "contained", className: classes.buttonError, onClick: onRejectClick, disabled: isButtonsDisabled }, rejectButtonText))))))))),
                react_1.default.createElement(core_1.TableCell, { width: "15%" }, resolutionDate && react_1.default.createElement(react_intl_1.FormattedDate, { value: resolutionDate }))));
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.TableContainer, { component: core_1.Paper },
            react_1.default.createElement(core_1.Table, null,
                react_1.default.createElement(core_1.TableHead, null,
                    react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, null,
                            react_1.default.createElement(core_1.Typography, null,
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "resolutionsTable.number" }))),
                        react_1.default.createElement(core_1.TableCell, null,
                            react_1.default.createElement(core_1.Typography, null,
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "resolutionsTable.fio" }))),
                        react_1.default.createElement(core_1.TableCell, null,
                            react_1.default.createElement(core_1.Typography, null,
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "resolutionsTable.resolution" }))),
                        react_1.default.createElement(core_1.TableCell, null,
                            react_1.default.createElement(core_1.Typography, null,
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "resolutionsTable.resolutionDate" }))))),
                react_1.default.createElement(core_1.TableBody, null, renderRows()))),
        react_1.default.createElement(ConfirmationDialog_1.ConfirmationDialog, { id: "confirm-resolution", open: !!confirmButtonText, onConfirm: onConfirmAction, onCancel: onConfirmDialogCancel, confirmButtonText: confirmButtonText })));
};
